import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

const CONSENT_LABELS = { accepted: 'a accepté', refused: 'a refusé' };

export const RideGiftFields = ({ user, mode, setMode, expiresAt, setExpiresAt, days, setDays }) => (
  <div className="space-y-3 rounded-lg border border-zinc-700 p-3" data-testid="ride-gift-fields">
    <p className="text-xs text-zinc-400">
      Avantage distinct d’un abonnement : 1 seule course offerte, plafonnée à 10 km routiers. Le chauffeur est rémunéré normalement.
      Seul ce bénéficiaire reçoit l’e-mail du cadeau.
    </p>
    <Label className="text-zinc-300">Validité du cadeau</Label>
    <select value={mode} onChange={(e) => setMode(e.target.value)} data-testid="ride-gift-validity-mode"
      className="w-full bg-zinc-900 border border-zinc-700 rounded px-3 py-2 text-white">
      <option value="date">Jusqu’à une date précise (heure de Paris)</option>
      <option value="days">Pendant un nombre de jours après attribution</option>
    </select>
    {mode === 'date' ? (
      <Input type="datetime-local" value={expiresAt} onChange={(e) => setExpiresAt(e.target.value)} data-testid="ride-gift-expires-at" />
    ) : (
      <Input type="number" min="1" max="365" value={days} onChange={(e) => setDays(e.target.value)} data-testid="ride-gift-valid-days" />
    )}
    <p className="text-xs text-zinc-500" data-testid="ride-gift-consent-info">
      Offres commerciales : {CONSENT_LABELS[user?.marketing_consent?.status] || 'pas encore de réponse'} (information, l’e-mail du cadeau reste individuel).
    </p>
  </div>
);
